import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Status as GrpcStatusCodes } from '@grpc/grpc-js/build/src/constants';
import { StatusCodes } from 'http-status-codes';
import HTTPMethod from 'http-method-enum';
import { defaultHeaders } from '@yoweb/utils/defaultHeaders';
export var ApiResponseStatus; // Translation keys for errors to be displayed to the end-user.

(function (ApiResponseStatus) {
  ApiResponseStatus["OK"] = "OK";
  ApiResponseStatus["ERROR"] = "ERROR";
  ApiResponseStatus["INVALID_AUTH_SESSION"] = "INVALID_AUTH_SESSION";
})(ApiResponseStatus || (ApiResponseStatus = {}));

export var defaultFriendlyError = {
  titleKey: 'title-generic',
  messageKey: 'generic'
};
var GENERIC_ERROR_RESPONSE = {
  status: ApiResponseStatus.ERROR,
  error: defaultFriendlyError
};

var getFriendlyError = function getFriendlyError(error, errorMap) {
  var _error$code = error.code,
      code = _error$code === void 0 ? GrpcStatusCodes.UNKNOWN : _error$code,
      _error$message = error.message,
      message = _error$message === void 0 ? '' : _error$message;
  var errorList = errorMap === null || errorMap === void 0 ? void 0 : errorMap[code];

  if (!errorList) {
    return GENERIC_ERROR_RESPONSE;
  }

  var key = Object.keys(errorList).find(function (key) {
    return message.includes(key);
  });
  var friendlyError = key && errorList[key] ? errorList[key] : {
    titleKey: 'title-generic',
    messageKey: 'payment'
  };
  return _objectSpread(_objectSpread({}, GENERIC_ERROR_RESPONSE), {}, {
    error: friendlyError
  });
};

export var getPostOptions = function getPostOptions(body) {
  return {
    body: JSON.stringify(body),
    method: HTTPMethod.POST
  };
}; // Fetch function specific to RPCs. The plan here is to map GRPC error codes to an error code
// usable in the FE. Errors will be logged on the server side.

export var safeFetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options, errorMap) {
    var response, _yield$response$json, error, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url, _objectSpread({
              headers: defaultHeaders
            }, options));

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 17;
              break;
            }

            if (!(response.status === StatusCodes.UNAUTHORIZED.valueOf())) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              status: ApiResponseStatus.INVALID_AUTH_SESSION,
              error: defaultFriendlyError
            });

          case 6:
            _context.prev = 6;
            _context.next = 9;
            return response.json();

          case 9:
            _yield$response$json = _context.sent;
            error = _yield$response$json.error;
            return _context.abrupt("return", getFriendlyError(error, errorMap));

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](6);
            return _context.abrupt("return", GENERIC_ERROR_RESPONSE);

          case 17:
            if (!(response.status !== StatusCodes.NO_CONTENT)) {
              _context.next = 23;
              break;
            }

            _context.next = 20;
            return response.json();

          case 20:
            _context.t1 = _context.sent;
            _context.next = 24;
            break;

          case 23:
            _context.t1 = undefined;

          case 24:
            data = _context.t1;
            return _context.abrupt("return", {
              status: ApiResponseStatus.OK,
              data: data
            });

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 14]]);
  }));

  return function safeFetch(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();